import {
  getAllResponsibleRecognitionEventByLicenseAsync,
  getResponsibleRecognitionEventByIdAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useGetResponsibleRecognitionEventByIdAsync = () =>
  useMutation(getResponsibleRecognitionEventByIdAsync);

export const useGetAllResponsibleRecognitionEventByLicenseAsync = () =>
  useMutation(getAllResponsibleRecognitionEventByLicenseAsync);
